var map = {
	"./act.svg": 448,
	"./activation.svg": 449,
	"./api-checkbox.svg": 450,
	"./apple-pay.svg": 451,
	"./archive.svg": 452,
	"./arrow-down.svg": 453,
	"./arrow-narrow-left.svg": 454,
	"./arrow-next.svg": 455,
	"./arrow-right.svg": 456,
	"./arrow.svg": 457,
	"./avatar.svg": 458,
	"./barcode.svg": 459,
	"./bell-reminder.svg": 460,
	"./billing.svg": 461,
	"./book.svg": 462,
	"./building-24.svg": 376,
	"./burger.svg": 463,
	"./calendar.svg": 464,
	"./car-red.svg": 465,
	"./cash-register.svg": 466,
	"./cashbox.svg": 467,
	"./cashflow-2.svg": 468,
	"./cashflow.svg": 469,
	"./cashier-2.svg": 470,
	"./change.svg": 471,
	"./chat-2.svg": 472,
	"./chat.svg": 473,
	"./checkbox-cashbox.svg": 474,
	"./checkbox-signature.svg": 475,
	"./cheque.svg": 476,
	"./close.svg": 477,
	"./cloud-computing.svg": 478,
	"./cloud-server.svg": 479,
	"./cloud.svg": 480,
	"./compass.svg": 481,
	"./computer.svg": 482,
	"./continuous.svg": 483,
	"./copy.svg": 484,
	"./corners.svg": 485,
	"./cross.svg": 486,
	"./csv.svg": 487,
	"./danger-trash.svg": 488,
	"./decline.svg": 489,
	"./delete.svg": 490,
	"./deposit-2.svg": 491,
	"./deposit.svg": 492,
	"./devices.svg": 493,
	"./discount-2.svg": 494,
	"./discount.svg": 495,
	"./done-2.svg": 496,
	"./done-3.svg": 497,
	"./done-all.svg": 498,
	"./done-icon.svg": 499,
	"./done-success.svg": 500,
	"./done.svg": 501,
	"./download-black.svg": 502,
	"./download.svg": 503,
	"./edit.svg": 504,
	"./editor.svg": 505,
	"./exclamation-2.svg": 506,
	"./exclamation-warning-2.svg": 421,
	"./exclamation-warning.svg": 507,
	"./exclamation.svg": 508,
	"./export.svg": 509,
	"./facebook.svg": 510,
	"./faq.svg": 511,
	"./filter-lines.svg": 512,
	"./finances-report.svg": 513,
	"./folder-plus.svg": 514,
	"./folder.svg": 515,
	"./forbidden.svg": 516,
	"./front-integration.svg": 517,
	"./frost.svg": 518,
	"./goods-2.svg": 519,
	"./goods.svg": 520,
	"./goodscollections.svg": 521,
	"./google-pay.svg": 522,
	"./google-plus.svg": 523,
	"./hand-track.svg": 524,
	"./headphones-customer-support.svg": 525,
	"./headset-white.svg": 526,
	"./headset.svg": 527,
	"./import.svg": 528,
	"./info-mark.svg": 529,
	"./info.svg": 530,
	"./info_2.svg": 531,
	"./instagram.svg": 532,
	"./integrations-orange.svg": 533,
	"./integrations.svg": 534,
	"./interlock.svg": 535,
	"./invoice-2.svg": 536,
	"./invoice.svg": 537,
	"./key-sign.svg": 538,
	"./key.svg": 539,
	"./key_green.svg": 540,
	"./keyword.svg": 541,
	"./little_arrow.svg": 542,
	"./little_x.svg": 543,
	"./location-2.svg": 544,
	"./location.svg": 545,
	"./login-2.svg": 546,
	"./login.svg": 547,
	"./logout-2.svg": 548,
	"./logout-3.svg": 549,
	"./logout-4.svg": 550,
	"./logout.svg": 551,
	"./marketing.svg": 552,
	"./maskbarcodes.svg": 553,
	"./mastercard.svg": 422,
	"./menu.svg": 554,
	"./messages.svg": 555,
	"./mobile.svg": 556,
	"./modifiers.svg": 557,
	"./money-transaction.svg": 558,
	"./money.svg": 559,
	"./money_disabled.svg": 560,
	"./money_enabled.svg": 561,
	"./network.svg": 562,
	"./next-3.svg": 563,
	"./notification-2.svg": 564,
	"./notification.svg": 565,
	"./organization.svg": 566,
	"./outlet.svg": 567,
	"./outlets.svg": 568,
	"./paper.svg": 569,
	"./password.svg": 570,
	"./pay-2.svg": 571,
	"./pay.svg": 572,
	"./paymaster.svg": 573,
	"./payment-card.svg": 574,
	"./payment.svg": 575,
	"./pdf.svg": 576,
	"./percent.svg": 577,
	"./person-white.svg": 578,
	"./person.svg": 579,
	"./phone-2.svg": 580,
	"./phone.svg": 581,
	"./plu.svg": 582,
	"./plus.svg": 583,
	"./price.svg": 584,
	"./pricelevels.svg": 585,
	"./primary-plus.svg": 586,
	"./primary-refresh.svg": 587,
	"./printer.svg": 588,
	"./qr-code.svg": 589,
	"./question-mark.svg": 590,
	"./question.svg": 591,
	"./read.svg": 592,
	"./receipt-report.svg": 593,
	"./receipt.svg": 594,
	"./reconciliation-act.svg": 595,
	"./referral-code.svg": 596,
	"./refresh.svg": 597,
	"./replenishmentprefixes.svg": 598,
	"./reports-dark.svg": 599,
	"./reports.svg": 600,
	"./rro-agent.svg": 601,
	"./scv.svg": 602,
	"./sell-2.svg": 603,
	"./sell-3.svg": 604,
	"./sell.svg": 605,
	"./selling-2.svg": 606,
	"./selling-3.svg": 607,
	"./selling.svg": 608,
	"./send.svg": 609,
	"./seo-report.svg": 610,
	"./settings-2.svg": 611,
	"./settings-3.svg": 612,
	"./settings-4.svg": 377,
	"./settings.svg": 613,
	"./shift.svg": 614,
	"./shop.svg": 615,
	"./shopping-cart-2.svg": 616,
	"./shopping-cart-3.svg": 617,
	"./shopping-cart.svg": 618,
	"./signature-agent.svg": 619,
	"./signature.svg": 620,
	"./star_active.svg": 621,
	"./star_empty.svg": 622,
	"./tax-report.svg": 623,
	"./taxes-2.svg": 624,
	"./taxes-report.svg": 625,
	"./taxes.svg": 626,
	"./telegram-2.svg": 627,
	"./telegram.svg": 628,
	"./tellersettings.svg": 629,
	"./templatenotifications.svg": 630,
	"./trash.svg": 631,
	"./update-arrow.svg": 632,
	"./upload.svg": 633,
	"./user.svg": 634,
	"./users.svg": 635,
	"./viber-2.svg": 636,
	"./viber.svg": 637,
	"./visa-white.svg": 423,
	"./visa.svg": 638,
	"./voucher.svg": 639,
	"./vouchers.svg": 640,
	"./warning-2.svg": 641,
	"./warning.svg": 642,
	"./work-start.svg": 643,
	"./workplace.svg": 644,
	"./wrench.svg": 645,
	"./xlsx.svg": 646,
	"./yellow-book.svg": 647,
	"./youtube.svg": 648,
	"./z-report.svg": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1128;